import React from 'react';
import { Monitor, Laptop, Server, Network, Usb, ShoppingCart, Package, Settings, Headphones, Printer } from 'lucide-react';
import { Card } from './ui/card';
import { products, services } from '../data/mockData';

const iconMap = {
  monitor: Monitor,
  laptop: Laptop,
  server: Server,
  network: Network,
  usb: Usb,
  'shopping-cart': ShoppingCart,
  package: Package,
  settings: Settings,
  headphones: Headphones,
  printer: Printer
};

export const ProductsServices = () => {
  return (
    <section id="products-services" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1e3a8a] mb-4">
            Products & Services
          </h2>
          <p className="text-lg text-gray-600">Comprehensive IT solutions for your organization</p>
        </div>

        {/* Products */}
        <div className="mb-16">
          <h3 className="text-2xl font-semibold text-[#1e3a8a] mb-8 text-center">
            Products
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {products.map((product) => {
              const IconComponent = iconMap[product.icon];
              return (
                <Card key={product.id} className="p-8 text-center hover:shadow-xl transition-all duration-300 bg-white border-gray-200 hover:border-teal-500">
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-teal-50 rounded-full flex items-center justify-center group-hover:bg-teal-100 transition-colors duration-300">
                      <IconComponent className="text-teal-600" size={32} />
                    </div>
                  </div>
                  <h4 className="text-gray-800 font-semibold text-base">{product.title}</h4>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Services */}
        <div>
          <h3 className="text-2xl font-semibold text-[#1e3a8a] mb-8 text-center">
            Services
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
            {services.map((service) => {
              const IconComponent = iconMap[service.icon];
              return (
                <Card key={service.id} className="p-8 text-center hover:shadow-xl transition-all duration-300 bg-white border-gray-200 hover:border-teal-500">
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-teal-50 rounded-full flex items-center justify-center group-hover:bg-teal-100 transition-colors duration-300">
                      <IconComponent className="text-teal-600" size={32} />
                    </div>
                  </div>
                  <h4 className="text-gray-800 font-semibold text-base">{service.title}</h4>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};